<template>
  <div
    class="emd-select"
    :class="[`_size_${size}`]"
  >
    <select
      data-testid="select-field"
      :disabled="disabled"
      :required="required"
      :value="value"
      @change="$emit('input', $event.target.value)"
      :name="name"
      :id="name"
    >
      <slot />
    </select>
    <div class="emd-select__arrow"></div>
  </div>
</template>

<script>
export default {
  name: 'EmdSelect',
  props: {
    size: {
      type: String,
      required: false,
      default: ''
    },
    value: {
      required: true
    },
    name: {
      required: false,
      type: String
    },
    required: {
      required: false,
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
